import React ,{useEffect,useState} from 'react';
import { useLocation,useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";


function AddCategory() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const categoryId = queryParams.get("id"); // <-- null for Add, string for Edit
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [formdata, setForm] = useState({ name:"",description:""});
      const [errors, setErrors] = useState({});
      const [loading, setLoading] = useState(false);
      const [message, setMessage] = useState("");

      useEffect(() => {
        if (categoryId) {
          const fetchCategory = async () => {
            try {
              const { data } = await apiClient.get(ADMIN.GET_CATEGORY);
              if (data.success) {
                const category = data.items.find(p => p._id === categoryId);
                if (category) {
                  setForm({
                    name: category.name,
                    description: category.description,
                  });
                }
              }
            } catch (err) {
              console.error("Error fetching category:", err);
              toast.error(err.response?.data?.message || err.message || "Failed to fetch category data");
            }
          };
          fetchCategory();
          }
        }, [categoryId]);
      
    
      const validate = () => {
        const e = {};
        if (!formdata.name || formdata.name.trim().length < 3)
          e.name = "Name must be at least 3 chars";
        if (!formdata.description) e.description = "Description required";
        setErrors(e);
        return Object.keys(e).length === 0;
      };
    
      const formChangeData = (ev) => {
        const { name, value } = ev.target; {
            setForm((f) => ({ ...f, [name]: value }));
          }
          setMessage("");
      };
    
      const handleSubmit = async (ev) => {
  ev.preventDefault();
  if (!validate()) return;
  setLoading(true);
  setMessage("");

  try {
    const url = categoryId ? ADMIN.UPDATE_CATEGORY(categoryId) : ADMIN.ADD_CATEGORY;
    const method = categoryId ? "put" : "post";

    const { data } = await apiClient[method](url, formdata);
    if (!data.success) throw new Error(data?.message || "Operation failed");

    toast.success(data.message || (categoryId ? "Category updated successfully" : "Category added successfully"));
    if(!categoryId){
      setForm({ name:"", description:"" });
    }
    setTimeout(() => {
      navigate("/category");
    }, 1000);
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Operation failed");
  } finally {
    setLoading(false);
  }
};

  return (
    
    <div>
        
      <div className="col-12 grid-margin container-scroller" >
                <div className="card">
                  <div className="card-body" >
                    <h4 className="card-title"></h4>
                    <form method="post" onSubmit={handleSubmit} className="form-sample">
                      <p className="card-description"> Add Category </p>
                      <div className="row">

                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Name</label>
                            <div className="col-sm-9">
                              <input type="text" name="name" value={formdata.name} onChange={formChangeData} className="form-control" />
                              {errors.name && <small className="text-danger">{errors.name}</small>}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Description</label>
                            <div className="col-sm-9">
                              <input type="text" name="description" value={formdata.description} onChange={formChangeData} className="form-control" />
                              {errors.description && <small className="text-danger">{errors.description}</small>}
                            </div>
                          </div>
                        </div>
                      </div>

                        
                        <div className="row mt-3">
                          <div className="col-md-12 text-center">
                            <button 
                              type="submit" 
                              className="btn btn-primary" 
                              >
                              Submit
                            </button>
                          </div>
                        </div>
                    </form>
                  </div>
                </div>
              </div>
    </div>
  )
}

export default AddCategory
